import FaqContent from "./components/FaqContent";
import styles from "./FAQPage.module.css";

const FAQPage = () => {
  return (
    <div className={styles.faqpage}>
      <FaqContent />
    </div>
  );
};

export default FAQPage;
